import { render, staticRenderFns } from "./AllMagazineAriticleDraggable.vue?vue&type=template&id=6698c428&"
import script from "./AllMagazineAriticleDraggable.vue?vue&type=script&lang=js&"
export * from "./AllMagazineAriticleDraggable.vue?vue&type=script&lang=js&"
import style0 from "./AllMagazineAriticleDraggable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports